export const SET_LISTING = 'SET_LISTING';
